<template>
    <kiosk-team-details :teamId="props.teamId">
        <div class="col-span-12 lg:col-span-10 flex flex-col w-full justify-center">
            <page-callout section="kiosk-team-proforma-invoices" class="mb-4" />

            <team-proforma-invoices :team-id="team.id" :payment-terms-days="team.payment_terms_days" />
        </div>
    </kiosk-team-details>
</template>

<script setup>
import KioskTeamDetails from '~/components/kiosk/kiosk-teams/details/KioskTeamDetails.vue';
import { useTeamDetails } from '~/components/kiosk/kiosk-teams/composables/useTeamDetails';
import PageCallout from '~/components/general/PageCallout.vue';
import TeamProformaInvoices from '~/components/settings/billing/TeamProformaInvoices.vue';

const { team } = useTeamDetails();

const props = defineProps({
    teamId: {
        type: Number,
        required: true,
    },
});
</script>
